export const BRAND_NAME = "Senco";
